module.exports = __webpack_public_path__ + "img/N539.6b4ab293.jpg";